import { Component, Prop, Vue } from 'vue-property-decorator';
import { isMembershipEnabled } from '@/helpers/Membership';
@Component({ name: 'MembershipLink' })
export default class default_1 extends Vue {
    // This only needs to be a prop so that the default can be excluded.
    @Prop({ default: 'register' })
    classNames;
    @Prop({ default: false })
    renew;
    get path() {
        return this.renew ? '/membership/renew' : '/membership';
    }
    get isMembershipEnabled() {
        return isMembershipEnabled(this.flags);
    }
    constructor() {
        super();
    }
}
